import api from './api';
import {
  hydratePenaltyCollection,
  hydratePenaltyRecord
} from '../utils/translationHydrator';

const hydratePenaltyPayload = (payload) => {
  if (!payload) {
    return payload;
  }

  if (Array.isArray(payload.data)) {
    return { ...payload, data: hydratePenaltyCollection(payload.data) };
  }

  if (payload.data) {
    return { ...payload, data: hydratePenaltyRecord(payload.data) };
  }

  return payload;
};

class PenaltyAdminService {
  async list(params = {}) {
    const response = await api.get('/penalties', { params });
    return hydratePenaltyPayload(response.data);
  }

  async get(penaltyId) {
    const response = await api.get(`/penalties/${penaltyId}`);
    return hydratePenaltyPayload(response.data);
  }

  async create(payload) {
    const response = await api.post('/penalties', payload);
    return hydratePenaltyPayload(response.data);
  }

  async updateStatus(penaltyId, payload) {
    const response = await api.patch(`/penalties/${penaltyId}/status`, payload);
    return hydratePenaltyPayload(response.data);
  }

  async addEvent(penaltyId, payload) {
    const response = await api.post(`/penalties/${penaltyId}/events`, payload);
    return hydratePenaltyPayload(response.data);
  }

  /**
   * Apply a monetary penalty (execute collection from deposit/payouts)
   * @param {string} penaltyId - The penalty ID
   * @param {object} options - Optional: victim_user_id, victim_has_stripe
   */
  async apply(penaltyId, options = {}) {
    const response = await api.post(`/penalties/${penaltyId}/apply`, options);
    return hydratePenaltyPayload(response.data);
  }

  /**
   * Get penalties linked to a specific source
   * @param {string} sourceType - Source type: dispute, fraud_case, kyc_case, etc.
   * @param {string} sourceId - Source ID (UUID)
   */
  async getBySource(sourceType, sourceId) {
    const response = await api.get('/penalties', {
      params: { source_type: sourceType, source_id: sourceId }
    });
    return hydratePenaltyPayload(response.data);
  }

  /**
   * Mark victim as manually compensated
   * @param {string} penaltyId - The penalty ID
   * @param {object} options - { compensation_method, compensation_reference, notes }
   */
  async markVictimCompensated(penaltyId, options = {}) {
    const response = await api.post(`/penalties/${penaltyId}/mark-compensated`, options);
    return hydratePenaltyPayload(response.data);
  }
}

export default new PenaltyAdminService();
